export enum InfoBlockType {
    info,
    error,
    warning,
    success,
}
